import { SomethingWrong } from "@/pages/somethingWrong";
import * as Sentry from "@sentry/react";
import { useLocation } from "react-router-dom";

const ErrorBoundaryWithReset: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  return (
    <Sentry.ErrorBoundary
      key={location.pathname}
      beforeCapture={scope => {
        scope.setTag("route", window.location.pathname);
        scope.setTag("page_name", "error_page");
      }}
      fallback={<SomethingWrong />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundaryWithReset;
